import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSpotSwapUserConfig } from '~/state/dex/hooks'
import { RowBetween } from '~/components/Layout'
import EditRecipientModal from './EditRecipientModal'
import styled from 'styled-components'

const StyledContainer = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-weight: 400;
`

const StyledLabel = styled.div`
  color: ${({ theme }) => theme.colors.textGrey2};
`

const StyledEditBtn = styled.button`
  border: none;
  background: none;
  padding: 0;
  color: #604dbc;
  cursor: pointer;
`

const StyledText = styled.div`
  margin-top: 8px;
  border-radius: 8px;
  padding: 12px;
  background-color: #f7f8f9;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.colors.textBlack2};
`

const Recipient = () => {
  const { t } = useTranslation()
  const { recipient } = useSpotSwapUserConfig()
  const [isOpenEditModal, setIsOpenEditModal] = useState(false)

  return (
    <>
      <StyledContainer>
        <RowBetween>
          <StyledLabel>{t('recipient_address')}</StyledLabel>
          <StyledEditBtn onClick={() => setIsOpenEditModal(true)}>
            {t('edit')}
          </StyledEditBtn>
        </RowBetween>
        <StyledText>{recipient}</StyledText>
      </StyledContainer>
      <EditRecipientModal
        isOpen={isOpenEditModal}
        handleDismiss={() => setIsOpenEditModal(false)}
      />
    </>
  )
}

export default Recipient
